import { storage } from './atomForLocal';
const STORAGE_KEY_PREFIX = 'challenge_modal_dismissed::';
export function isDismissedToday(challengeId) {
    const today = new Date().toDateString();
    const dismissed = storage.getString(`${STORAGE_KEY_PREFIX}${challengeId}`);
    if (!dismissed) {
        return false;
    }
    try {
        const records = JSON.parse(dismissed);
        return records[challengeId] === today;
    }
    catch (_a) {
        return false;
    }
}
export function setDismissedToday(challengeId) {
    const today = new Date().toDateString();
    const dismissed = storage.getString(`${STORAGE_KEY_PREFIX}${challengeId}`);
    let records = {};
    if (dismissed) {
        try {
            records = JSON.parse(dismissed);
        }
        catch (_a) {
            // Ignore parse errors and start fresh
        }
    }
    records[challengeId] = today;
    storage.set(`${STORAGE_KEY_PREFIX}${challengeId}`, JSON.stringify(records));
}
